
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import "../../index.css";
import { useAppSelector } from "../../app/hooks";
import LoadingSpinner from "../common/Loading";
import NoDataMessage from "../../components/common/NoDataMessage";
import ShiftTable from "../common/table";
import { EmployeeBanner } from "../shift/employee-banner";
import { styles } from "./styles";
import { ShiftMemberDetailsHeader } from "../../utils/headers";

const ShiftMemberDetails = ({ apiData, bannerDetails, tableData }: any) => {
  const {
    isGetShiftDutyByIdLoading,
  }: any = useAppSelector((state) => state.shift);

  return (

    <Box >
      {isGetShiftDutyByIdLoading && <LoadingSpinner fullScreen />}
      <EmployeeBanner selectedMember={bannerDetails} />
      <Box sx={styles.employeeBannerMainContainer} >
        <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1} mt={2}>
          <Typography
            variant="h6"
            gutterBottom
            sx={styles.shiftHistoryText}
          >
            Shift History
          </Typography>
          <Typography variant="h6" sx={styles.employeeProfileBackButton}
          >
            Current Week
          </Typography>
        </Box>
        <Box sx={{ justifyContent: "center", margin: "auto", width: "100%" }}>
          {(apiData?.length === 0 || apiData === undefined) && <NoDataMessage />}
          {(apiData?.length > 0 && apiData !== undefined) && <ShiftTable headers={ShiftMemberDetailsHeader} data={[...tableData].reverse()} noColumnBorders={true} borderCustomColor="#EBEBEB" />}
        </Box>
      </Box>
    </Box>
  );
};
export default ShiftMemberDetails;